<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="taxInfoAudits && taxInfoAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list [audits]="taxInfoAudits" (nextPage)="onNextPage()">
    </sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Tax Info audits </ng-template>
</ng-template>
